
<div class="slider">
  <div class="slide" [ngStyle]="{ 'background-image': getCurrentSlideUrl() }"></div>
  <div class="dotsContainer">
    <div
      *ngFor="let slide of slides; let slideIndex = index"
      class="dot"
      [class.active]="slideIndex === currentIndex"
      (click)="goToSlide(slideIndex)"
    >
      ●
    </div>
  </div>
</div>
